module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><g fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(2 2)\"><circle cx=\"14\" cy=\"14\" r=\"15\" stroke=\"#E93D19\" stroke-width=\"2\"></circle><path fill=\"#E93D19\" fill-rule=\"nonzero\" d=\"M18.348 18.849a1.2 1.2 0 0 1-1.697 0L14 15.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L14 12.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic-project-cancelled.svg
// module id = 873
// module chunks = 1